import { useTranslation } from 'react-i18next';
import stackStyle from './Stack.module.scss';
import commonStyle from '../../../styles/commonStyles.module.scss';
import { stackGroups } from '../../../data/skills';
import SectionHeading from '../../elements/sectionHeading/SectionHeading';
import Reveal from '../../elements/reveal/Reveal';

const Stack = () => {
    const { t } = useTranslation();

    return (
        <section className={stackStyle.section}>
            <div className={stackStyle.inner}>
                <SectionHeading eyebrow={t('stack.eyebrow')} title={t('stack.title')} description={t('stack.description')} />

                <div className={stackStyle.grid}>
                    {stackGroups.map((group, i) => (
                        <Reveal key={group.title} delay={i * 60} className={stackStyle.cell}>
                            <div className={stackStyle.card}>
                                <h3 className={stackStyle.cardTitle}>{group.title}</h3>
                                <div className={commonStyle.tagRow}>
                                    {group.items.map((item) => (
                                        <span key={item} className={commonStyle.tag}>
                                            {item}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Stack;
